import styles from '../Responsive.module.scss'

const Desktop = ({ children }) => <div className={styles.desktop}>{children}</div>

export default Desktop
